import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
// prime react
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
// components
import { TableData } from "./TableData";
import usePermission from "../../../hooks/usePermission";
import { getViewAllShipping } from "../../../services/Financial/viewShipping/getViewAllShipping";
import { Skeleton } from "primereact/skeleton";
import { useAppContext } from "../../../context/AppContext";

const ViewShipping = () => {

  usePermission("125"); // Visualizar Fila de Remessa
  const { permissions } = useAppContext();
  const [loading, setLoading] = useState(true)
  // Gerenciar os dados e carregamento usando useQuery
  const { data, refetch } = useQuery({
    queryKey: ["viewShipping"],
    queryFn: () => getViewAllShipping(),
    enabled: permissions?.includes("125"),
    retry: false,
    onSuccess: (data) => {
      setDataTable(data);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  const [dataTable, setDataTable] = useState([]);

  const form = useForm();
  const errors = form.formState.errors;

  const items = [
    {
      template: () => (
        <Link to={"/financial/viewShipping"} className="p-breadcrumb-link">
          Visualizar Remessas
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  // Atualizar os dados da tabela quando a consulta for bem-sucedida
  useEffect(() => {
    if (!loading && data) {
      setDataTable(data || []);
    }
  }, [data, loading]);

  // Função para atualizar os dados e forçar o esqueleto a aparecer
  const handleRefresh = async () => {
    setLoading(true)
    await refetch();  // Reexecuta a query para carregar os novos dados
    setLoading(false);
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div className="row p-0">
          <div className="col-xl-4 col-md-6">
            <BreadCrumb
              model={items}
              home={home}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "16px",
              }}
            />
          </div>
          <div className="col-xl-8 col-md-6 text-end p-0">
            <div className="row justify-content-end pb-3">
              <div className="col-xl-3 col-md-6">
                <Button
                  disabled={loading}
                  rounded
                  severity="success"
                  label="Atualizar"
                  icon="fa fa-arrows-rotate"
                  onClick={handleRefresh}  // Chamando a função handleRefresh no clique
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
            </div>
          </div>
        </div>
        {/* Exibe o Skeleton enquanto os dados estão sendo carregados */}
        {loading && <Skeleton width="100%" height="400px" />}
        {/* Exibe a tabela quando o carregamento terminar */}
        {!loading && <TableData dataTable={dataTable} />}
      </div>
    </>
  );
};

export default ViewShipping;
